import { render } from "./NewShitpostForm.vue?vue&type=template&id=0908abba"
import script from "./NewShitpostForm.vue?vue&type=script&lang=js"
export * from "./NewShitpostForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\joseph\\Desktop\\Vue Projects\\shitpost\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__